import Typography from 'components/Typography';

import { PlainTextMessageProps } from './types';
import { StyledPlainMessageWrapper, StyledPlainTextContent, StyledSpacer } from './styles';
import { htmlId } from 'utils/html';

export const PlainTextMessage = ({
  align = 'left',
  contentWidth = '80%',
  hasTopGutter = false,
  text,
}: PlainTextMessageProps) => {
  return (
    <StyledPlainMessageWrapper
      id={htmlId('message-plain-text-wrapper')}
      align={align}
      hasTopGutter={hasTopGutter}
    >
      <StyledSpacer id={htmlId('message-plain-text-spacer')} />
      <StyledPlainTextContent
        id={htmlId('message-plain-text-content')}
        align={align}
        contentWidth={contentWidth}
      >
        <Typography
          as='span'
          variant='body'
          size='md'
          color={align === 'left' ? 'default' : 'inverse'}
        >
          {text}
        </Typography>
      </StyledPlainTextContent>
    </StyledPlainMessageWrapper>
  );
};
